/**
 * bubu-cumples.js — configurador de packs de cumple (6 pasos + repaso).
 *
 * - Estado en localStorage «bubu_wiz» (README «Estado»); nunca precios ni totales.
 * - Fecha de salida del lote: window.BubuTanda (única fuente de verdad).
 * - Añadir: una línea por personaje (producto del formato + propiedad «Personaje») y una
 *   por extra, todas con _pack_id / _pack_tipo (packs-cumple-shopify.md). Con ?editar=<id>
 *   el pack se recarga desde el carrito y al guardar se sustituye en su sitio.
 * - Animación de añadir: BubuAnim.grande (la «grande», centralizada en bubu-cart.js).
 */
const KEY = 'bubu_wiz';
const DIA = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
const DIA_L = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const MES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const DIA_MS = 86400000;
const TITULOS = ['¿Qué celebráis?', '¿Qué día es la fiesta?', '¿Qué pack eliges?', '¿Cuántos invitados?', '¿Qué slimes queréis?', '¿Añadimos algo más?', 'Resumen de tu pedido:'];
const SUBT = [
  'Nos ayudará a entender mejor tu fiesta.',
  'Elige el día y te decimos si llega a tiempo.',
  'Elige el que más se adapte a lo que necesitas.',
  // El mínimo sigue viniendo del ajuste del tema, no escrito a mano: si algún día deja
  // de ser 10, el texto cambia solo y no se queda prometiendo un número que ya no es.
  'Mínimo {min}. Cuantos más invitados, más ahorras.',
  '',
  'Nada de esto hace falta para que tu fiesta funcione, pero ayudan a darle un extra.',
  'Esto es lo que vamos a añadir a tu carrito. Estás a tiempo de cambiar cualquier dato.',
];
const ICO = {
  ok: 'm5 12.6 4.6 4.6L19 7.2',
  warn: 'M12 8v5m0 3.5v.01M12 3 2.5 20h19z',
  no: 'M6 6l12 12M18 6 6 18',
};

const esMovil = () => window.innerWidth < 820;
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
const eur = (n) => (Math.round(n * 100) / 100).toFixed(2).replace('.', ',') + ' €';
const pad = (n) => (n < 10 ? '0' + n : '' + n);
const isoLocal = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const deIso = (iso) => new Date(iso + 'T12:00:00');
const fCorta = (d) => `${DIA[d.getDay()]} ${d.getDate()} ${MES[d.getMonth()].slice(0, 3)}`;
const fMedia = (d) => `${DIA[d.getDay()]} ${d.getDate()} ${MES[d.getMonth()]}`;
const svg = (path, tam, extra) => `<svg width="${tam}" height="${tam}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ${extra || ''}><path d="${path}"></path></svg>`;
const check = (tam) => svg(ICO.ok, tam || 12, 'stroke-width="3.4"');

function estadoInicial() {
  return { paso: 1, cel: '', fecha: '', calOff: 0, pack: 'premium', inv: 12, modelos: 'iguales', asign: {}, extras: {}, obs: '', editando: null, guardado: false };
}

class BubuCumples extends HTMLElement {
  connectedCallback() {
    if (this._ok) return;
    this._ok = true;
    try {
      this.d = JSON.parse(this.querySelector('[data-bubu-cumples-datos]').textContent);
    } catch (_) {
      this.d = null;
    }
    if (!this.d) return;
    this.d.min = Number(this.d.min) || 10;
    this.d.max = Number(this.d.max) || 80;
    this.d.tramos = (this.d.tramos || [10, 20, 30]).map(Number);
    this.d.presets = (this.d.presets || []).map((x) => parseInt(x, 10)).filter((x) => x >= this.d.min);
    this.d.formatos.forEach((f) => { f.lineas = (f.lineas || []).map((l) => String(l).trim()).filter(Boolean); });
    this.d.celebraciones = (this.d.celebraciones || []).map((c) => String(c).trim()).filter(Boolean);

    this.st = estadoInicial();
    this.st.cel = this.d.celebraciones[0] || 'Cumple';
    this.st.inv = Math.max(this.d.min, 12);
    const previo = this.leer();
    if (previo && previo.paso) Object.assign(this.st, previo, { guardado: true, editando: null });

    this.$paso = this.querySelector('[data-wiz-paso]');
    this.$nav = this.querySelector('[data-wiz-nav]');
    this.$rail = this.querySelector('[data-wiz-rail]');
    this.$avisos = this.querySelector('[data-wiz-avisos]');
    this.$lbl = this.querySelector('[data-wiz-paso-lbl]');
    this.$barra = this.querySelector('[data-wiz-barra]');
    this.$cab = this.querySelector('.bubu-wiz__cab');
    this.navMonta();

    this.addEventListener('click', (e) => this.onClick(e));
    this.addEventListener('input', (e) => this.onInput(e));
    this.addEventListener('change', (e) => this.onInput(e));
    this.addEventListener('keydown', (e) => {
      const card = e.target.closest && e.target.closest('[data-wiz-pack]');
      if (card && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); card.click(); }
    });
    window.addEventListener('resize', () => { const m = esMovil(); if (m !== this._mob) { this._mob = m; this.render(); } });
    document.addEventListener('bubu:tanda', () => { if (this.st.paso === 2 || this.st.paso === 7) this.render(); });
    this._mob = esMovil();

    const editar = new URLSearchParams(window.location.search).get('editar');
    if (editar) this.cargarDesdeCarrito(editar).finally(() => { this.render(); this.avisaPaso(this.st.paso); });
    else { this.render(); this.avisaPaso(this.st.paso); }
  }

  // ---------- persistencia ----------
  leer() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (_) { return null; } }
  guardar() {
    if (this.st.editando) return;
    const { paso, cel, fecha, pack, inv, modelos, asign, extras, obs } = this.st;
    try { localStorage.setItem(KEY, JSON.stringify({ paso, cel, fecha, pack, inv, modelos, asign, extras, obs })); } catch (_) { /* sin almacenamiento */ }
  }
  borrar() { try { localStorage.removeItem(KEY); } catch (_) { /* nada */ } }
  set(cambios) { Object.assign(this.st, cambios); this.guardar(); this.render(); }

  // ---------- cálculo ----------
  formato() { return this.d.formatos.find((f) => f.k === this.st.pack) || this.d.formatos[0]; }
  tramoIdx(inv) { const t = this.d.tramos; return inv >= t[2] ? 2 : inv >= t[1] ? 1 : 0; }
  pud() { return Number(this.formato().precios[this.tramoIdx(this.st.inv)]) || 0; }
  asignados() { return Object.keys(this.st.asign).reduce((s, k) => s + (this.st.asign[k] || 0), 0); }
  extrasTotal() { return Object.keys(this.st.extras).reduce((s, k) => { const e = this.d.extras.find((x) => x.k === k); return s + (e ? (this.st.extras[k] || 0) * e.p : 0); }, 0); }
  personaje(s) { return this.d.personajes.find((p) => p.s === s); }
  setInv(n) {
    const inv = Math.min(this.d.max + 40, Math.max(this.d.min, parseInt(n, 10) || this.d.min));
    const st = this.st;
    let asign = st.asign;
    if (st.modelos === 'iguales') {
      const k = Object.keys(st.asign).filter((x) => st.asign[x] > 0)[0];
      asign = k ? { [k]: inv } : {};
    } else {
      const tot = this.asignados();
      if (tot > inv) {
        asign = {}; let queda = inv;
        Object.keys(st.asign).forEach((x) => { const q = Math.min(st.asign[x] || 0, queda); if (q > 0) { asign[x] = q; queda -= q; } });
      }
    }
    this.set({ inv, asign });
  }

  aviso() {
    const st = this.st, n = this.asignados(), ig = st.modelos === 'iguales';
    if (st.paso === 2 && !st.fecha) return 'Elige el día de la fiesta en el calendario.';
    if (st.paso === 3 && !this.formato().id) return 'Este formato aún no está disponible.';
    if (st.paso === 4 && st.inv < this.d.min) return `Los packs de fiesta empiezan en ${this.d.min} invitados.`;
    if (st.paso === 5 && n === 0) return ig ? 'Elige el personaje de la fiesta.' : 'Elige al menos un personaje.';
    if (st.paso === 5 && !ig && n < st.inv) return `Te faltan ${st.inv - n} por repartir.`;
    if (st.paso > 5 && n !== st.inv) return `Tienes ${n} slimes repartidos para ${st.inv} invitados. Vuelve al paso 5.`;
    return '';
  }

  // Salida del lote: BubuTanda si está, si no el lunes siguiente.
  salidaLote() {
    if (window.BubuTanda && typeof window.BubuTanda.calcula === 'function') {
      const t = window.BubuTanda.calcula();
      if (t && t.salida) return new Date(t.salida);
    }
    const d = new Date(); d.setHours(0, 0, 0, 0);
    let add = (8 - d.getDay()) % 7; if (add === 0) add = 7;
    return new Date(d.getTime() + add * DIA_MS);
  }
  llegada(sal) { const d = new Date(sal); d.setDate(d.getDate() + 2); return d; }
  frescoSalida() {
    const d = deIso(this.st.fecha); d.setDate(d.getDate() - 10);
    while (d.getDay() !== 1) d.setDate(d.getDate() - 1);
    return d;
  }
  // Regla única: un lote por semana, llega en 24–48 h; el margen se mide contra la llegada.
  semaforo() {
    if (!this.st.fecha) return null;
    const f = deIso(this.st.fecha);
    if (isNaN(f.getTime())) return null;
    const sal = this.salidaLote();
    const lleg = this.llegada(sal);
    const dias = Math.round((f - lleg) / DIA_MS);
    const lab = `${DIA[sal.getDay()]} ${sal.getDate()}`;
    if (dias > 21) {
      const s2 = this.frescoSalida();
      const l2 = new Date(s2); l2.setDate(l2.getDate() - 7);
      return { k: 'ok', icon: ICO.ok, lejana: true, salDate: s2, f: 'Hay tiempo de sobra.', s: `Lo fabricamos en el lote de la semana del ${l2.getDate()} de ${MES[l2.getMonth()]}: sale del Lab el lunes ${s2.getDate()} y llega recién hecho.` };
    }
    if (dias >= 2) return { k: 'ok', icon: ICO.ok, salDate: sal, f: `Llega con ${dias} ${dias === 1 ? 'día' : 'días'} de margen.`, s: `Sale del Lab el ${lab} y llega en 24–48 h.` };
    if (dias >= 0) return { k: 'warn', icon: ICO.warn, salDate: sal, f: 'Vas justo.', s: `Sale el ${lab} y llega en 24–48 h, justo a tiempo. Suele llegar, pero no lo podemos garantizar.` };
    return { k: 'no', icon: ICO.no, salDate: sal, f: 'No llegamos a esa fecha.', s: `El primer lote posible sale el ${lab} y llega sobre el ${DIA[lleg.getDay()]} ${lleg.getDate()}. Escríbenos y miramos qué podemos hacer.` };
  }

  // ---------- render ----------
  render() {
    const st = this.st, mob = esMovil(), aviso = this.aviso();
    const p = st.paso;
    this.$lbl.textContent = p > 6 ? 'Repaso final' : `Paso ${p} de 6`;
    this.$barra.style.width = `${Math.min(100, Math.round((p / 6) * 100))}%`;
    this.classList.toggle('is-repaso', p === 7);
    // La portada (kicker + «Un Bubu para cada invitado» + entradilla) solo tiene sentido
    // al entrar. A partir del paso 2 el cliente ya sabe dónde está y lo único que hace
    // es empujar hacia abajo la pregunta del paso —«¿Qué día es la fiesta?», «¿Cuántos
    // invitados?»—, que es lo único que hay que leer y contestar ahí. El protagonismo es
    // de la pregunta. Se esconde, no se borra: al volver al paso 1 reaparece igual.
    if (this.$cab) this.$cab.hidden = p !== 1;
    this.classList.toggle('is-editando', !!st.editando);

    // Avisos (edición / guardado)
    let av = '';
    if (st.editando) av += `<div class="bubu-wiz__edit"><span>Estás editando el pack que ya tienes en el carrito. Al guardar se sustituye, no se añade otro.</span><button type="button" class="bubu-wiz__edit-btn" data-wiz-cancelar>Dejarlo como estaba</button></div>`;
    // Aquí ya no se anuncia nada sobre el guardado. Ni «Vamos guardando tu pack…» ni
    // «Seguimos donde lo dejaste»: el progreso se guarda y punto, decirlo solo mete ruido
    // encima de la pregunta del paso, que es lo único que hay que leer. El único aviso que
    // queda en esta zona es el de edición, que sí cambia lo que va a pasar al guardar.
    this.$avisos.innerHTML = av;

    const titulo = `<h2 class="bubu-wiz__h3">${esc(TITULOS[p - 1])}</h2>`;
    const sub = p === 5 ? this.d.textos.personajes : SUBT[p - 1].replace('{min}', this.d.min);
    const cab = titulo + (sub ? `<p class="bubu-wiz__sub">${esc(sub)}</p>` : '');
    const cuerpos = [null, this.paso1, this.paso2, this.paso3, this.paso4, this.paso5, this.paso6, this.paso7];
    this.$paso.innerHTML = `<div class="bubu-wiz__cuerpo" data-paso="${p}">${cab}${cuerpos[p].call(this)}</div>`;

    // Navegación
    this.navPinta(p, aviso);
    this.$rail.innerHTML = mob || p === 7 ? '' : this.rail();
    this.$rail.hidden = mob || p === 7;
  }

  /* ------------------------------------------------------------------
     LA BARRA DE ABAJO SE MONTA UNA VEZ Y NO SE VUELVE A CONSTRUIR.

     Aquí estaba el «tengo que pulsar dos veces en Siguiente». La barra se rehacía
     entera con innerHTML en CADA repintado, y el repintado ocurre a cada toque:
     eliges el día, eliges el pack, mueves los invitados… Cada vez, el botón que hay
     debajo del dedo deja de ser el mismo nodo. Un toque del móvil no es un evento,
     son tres (pointerdown, pointerup y después click), y el navegador solo manda el
     click si el dedo baja y sube SOBRE EL MISMO elemento: si en medio lo has
     sustituido, el click se dispara en el contenedor, `closest('[data-wiz-sig]')` no
     encuentra nada y no pasa absolutamente nada. Pulsas otra vez —ya sin repintado en
     medio— y entonces sí avanza. Justo lo que cuentan.

     Ahora los nodos de la barra nacen una sola vez y el repintado solo les cambia el
     texto, el estado y si se ven o no. El botón de Siguiente es SIEMPRE el mismo
     elemento de principio a fin del asistente, así que ningún toque se puede perder
     por el camino.
     ------------------------------------------------------------------ */
  navMonta() {
    if (!this.$nav || this.$nav.dataset.montada === '1') return;
    this.$nav.dataset.montada = '1';
    this.$nav.innerHTML = `
      <div class="bubu-wiz__nav-prog"><span data-nav-prog></span><span class="bubu-wiz__barra bubu-wiz__barra--mini"><i data-nav-barra></i></span></div>
      <p class="bubu-wiz__aviso bubu-wiz__aviso--arriba" data-nav-aviso-mov hidden></p>
      <button type="button" class="bubu-btn bubu-btn--tinta bubu-wiz__atras" data-wiz-atras aria-label="Atrás" hidden>← Atrás</button>
      <div class="bubu-wiz__nav-der">
        <span class="bubu-wiz__aviso" data-nav-aviso-pc hidden></span>
        <button type="button" class="bubu-btn bubu-btn--marca bubu-wiz__sig"><span data-nav-sig-t></span><span class="bubu-wiz__sig-ico" data-nav-sig-ico hidden>${svg('M5 12h14m-6-7 7 7-7 7', 16)}</span></button>
      </div>`;
    this.$navProg = this.$nav.querySelector('[data-nav-prog]');
    this.$navBarra = this.$nav.querySelector('[data-nav-barra]');
    this.$navAvisoMov = this.$nav.querySelector('[data-nav-aviso-mov]');
    this.$navAvisoPc = this.$nav.querySelector('[data-nav-aviso-pc]');
    this.$navAtras = this.$nav.querySelector('[data-wiz-atras]');
    this.$navSig = this.$nav.querySelector('.bubu-wiz__sig');
    this.$navSigT = this.$nav.querySelector('[data-nav-sig-t]');
    this.$navSigIco = this.$nav.querySelector('[data-nav-sig-ico]');
  }

  navPinta(p, aviso) {
    if (!this.$navSig) return;
    const fin = p === 7;
    const etiqueta = p > 6 ? 'Repaso final' : `Paso ${p} de 6`;
    this.$navProg.textContent = etiqueta;
    this.$navBarra.style.width = `${Math.min(100, Math.round((p / 6) * 100))}%`;

    this.$navAvisoMov.textContent = aviso;
    this.$navAvisoMov.hidden = !aviso;
    this.$navAvisoPc.textContent = aviso;
    this.$navAvisoPc.hidden = !aviso;

    this.$navAtras.hidden = p <= 1;

    const b = this.$navSig;
    // El botón cambia de oficio en el repaso: deja de avanzar y pasa a añadir (o a
    // guardar, si se está editando un pack que ya está en el carrito). Cambia el
    // atributo, no el nodo.
    if (fin) {
      b.setAttribute('data-wiz-add', '');
      b.removeAttribute('data-wiz-sig');
    } else {
      b.setAttribute('data-wiz-sig', '');
      b.removeAttribute('data-wiz-add');
    }
    b.classList.toggle('bubu-wiz__add', fin);
    b.classList.toggle('is-bloqueado', !!aviso);
    b.disabled = !!aviso;
    if (aviso) b.setAttribute('aria-disabled', 'true');
    else b.removeAttribute('aria-disabled');
    this.$navSigT.textContent = fin
      ? (this.st.editando ? this.d.textos.guardar : this.d.textos.anadir)
      : p === 6
        ? 'Repasar y cerrar →'
        : 'Siguiente →';
    this.$navSigIco.hidden = !fin;
  }

  chips(lista, sel, attr, clase) {
    // `tag` es una etiqueta pequeña dentro del chip («Recomendado» en «Todos igual»).
    return `<div class="${clase || 'bubu-wiz__chips'}">${lista.map((n) => `<button type="button" class="bubu-wiz__chip${sel === n.k ? ' is-sel' : ''}" ${attr}="${esc(n.k)}">${esc(n.n)}${n.tag ? `<span class="bubu-wiz__reco">${esc(n.tag)}</span>` : ''}</button>`).join('')}</div>`;
  }

  paso1() {
    return this.chips(this.d.celebraciones.map((c) => ({ k: c, n: c })), this.st.cel, 'data-wiz-cel', 'bubu-wiz__celebras');
  }

  paso2() {
    const st = this.st;
    const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
    const base = new Date(hoy.getFullYear(), hoy.getMonth() + st.calOff, 1);
    const y = base.getFullYear(), m = base.getMonth();
    const dim = new Date(y, m + 1, 0).getDate();
    const off = (new Date(y, m, 1).getDay() + 6) % 7;
    let celdas = '';
    for (let i = 0; i < off; i++) celdas += '<span class="bubu-cal__c is-vacia"></span>';
    for (let d = 1; d <= dim; d++) {
      const dt = new Date(y, m, d), iso = isoLocal(dt);
      const pasado = dt < hoy, esHoy = dt.getTime() === hoy.getTime(), sel = st.fecha === iso;
      celdas += pasado
        ? `<span class="bubu-cal__c is-pasado">${d}</span>`
        : `<button type="button" class="bubu-cal__c${sel ? ' is-sel' : ''}${esHoy ? ' is-hoy' : ''}" data-wiz-fecha="${iso}" aria-label="${d} de ${MES[m]}"${sel ? ' aria-pressed="true"' : ''}>${d}</button>`;
    }
    const sm = this.semaforo();
    const fDia = st.fecha ? (() => { const d = deIso(st.fecha); return `${DIA_L[d.getDay()]} ${d.getDate()} de ${MES[d.getMonth()]}`; })() : '';
    return `
      <div class="bubu-wiz__dos">
        <div class="bubu-cal">
          <div class="bubu-cal__cab">
            <div class="bubu-cal__mes">${MES[m][0].toUpperCase() + MES[m].slice(1)} ${y}</div>
            <div class="bubu-cal__flechas">
              <button type="button" class="bubu-cal__flecha" data-wiz-cal="-1" aria-label="Mes anterior" ${st.calOff <= 0 ? 'disabled' : ''}>${svg('M15 5l-7 7 7 7', 15)}</button>
              <button type="button" class="bubu-cal__flecha" data-wiz-cal="1" aria-label="Mes siguiente" ${st.calOff >= 6 ? 'disabled' : ''}>${svg('M9 5l7 7-7 7', 15)}</button>
            </div>
          </div>
          <div class="bubu-cal__dias">${['L', 'M', 'X', 'J', 'V', 'S', 'D'].map((l) => `<span>${l}</span>`).join('')}</div>
          <div class="bubu-cal__grid">${celdas}</div>
          <div class="bubu-cal__leyenda"><span><i class="is-fiesta"></i>Tu fiesta</span><span><i class="is-hoy"></i>Hoy</span></div>
        </div>
        ${sm
          ? `<div class="bubu-sem is-${sm.k}"><div class="bubu-sem__cab"><span class="bubu-sem__ico">${svg(sm.icon, 18)}</span><div class="bubu-sem__f">${esc(sm.f)}</div></div><div class="bubu-sem__s">${esc(sm.s)}</div><div class="bubu-sem__pie"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7.5V12l3 2"></path></svg>Fiesta el ${esc(fDia)}</div></div>`
          : `<div class="bubu-sem is-vacio"><div class="bubu-sem__f">Toca un día del calendario.</div><div class="bubu-sem__s">Hacemos un lote por semana: el pedido sale del Lab el lunes siguiente a tu compra.</div></div>`}
      </div>`;
  }

  paso3() {
    const st = this.st, inv = st.inv;
    return `<div class="bubu-wiz__formatos">${this.d.formatos.map((f) => {
      const sel = st.pack === f.k;
      const pu = Number(f.precios[this.tramoIdx(inv)]) || 0;
      return `
        <div class="bubu-fmt${sel ? ' is-sel' : ''}${f.id ? '' : ' is-agotado'}" data-wiz-pack="${f.k}" role="button" tabindex="0" aria-pressed="${sel}">
          <div class="bubu-fmt__foto">${f.img ? `<img src="${esc(f.img)}" alt="${esc(f.n)}" loading="lazy">` : '<span class="bubu-fmt__ph">Foto del formato</span>'}<span class="bubu-fmt__radio">${check(15)}</span></div>
          <div class="bubu-fmt__cuerpo">
            <div class="bubu-fmt__n">${esc(f.n)}</div>
            <div class="bubu-fmt__vol">${esc(f.vol)}</div>
            <div class="bubu-fmt__precio"><span>${eur(pu)}</span><span class="bubu-fmt__por">por invitado</span></div>
            <div class="bubu-fmt__tier">*El precio baja según los invitados que elijas.</div>
            <div class="bubu-fmt__sep"></div>
            <div class="bubu-fmt__lineas">${f.lineas.map((l) => `<span><i>${check(9)}</i>${esc(l)}</span>`).join('')}</div>
            <div class="bubu-fmt__cta">${f.id ? (sel ? 'Formato elegido' : 'Elegir este formato') : 'No disponible ahora mismo'}</div>
          </div>
        </div>`;
    }).join('')}</div>`;
  }

  paso4() {
    const st = this.st, f = this.formato(), t = this.d.tramos, pu = this.pud();
    const tab = f.precios.map(Number);
    const frase = st.inv < t[1] ? `Con ${t[1]} invitados baja a ${eur(tab[1])} cada uno.` : st.inv < t[2] ? `Con ${t[2]} invitados baja a ${eur(tab[2])} cada uno.` : 'Estás en el mejor tramo.';
    return `
      <div class="bubu-wiz__dos bubu-wiz__dos--inv">
        <div class="bubu-inv">
          <div class="bubu-inv__stepper">
            <button type="button" class="bubu-inv__menos" data-wiz-inv="-1" aria-label="Quitar un invitado" ${st.inv <= this.d.min ? 'disabled' : ''}>−</button>
            <div class="bubu-inv__num"><div class="bubu-inv__n" data-inv-n>${st.inv}</div><div class="bubu-inv__lbl">invitados</div></div>
            <button type="button" class="bubu-inv__mas" data-wiz-inv="1" aria-label="Añadir un invitado">+</button>
          </div>
          <input type="range" class="bubu-inv__range" min="${this.d.min}" max="${this.d.max}" step="1" value="${Math.min(st.inv, this.d.max)}" data-wiz-range aria-label="Número de invitados" style="--pct:${Math.round(((Math.min(st.inv, this.d.max) - this.d.min) / (this.d.max - this.d.min)) * 100)}%">
          <div class="bubu-inv__minmax"><span>${this.d.min}</span><span>${this.d.max}+</span></div>
        </div>
        <div class="bubu-inv__lado">
          <div class="bubu-pud">
            <div class="bubu-pud__k">Precio por invitado</div>
            <div class="bubu-pud__p"><span data-pud-unit>${eur(pu)}</span><span class="bubu-pud__peque">/ invitado</span></div>
            <div class="bubu-pud__linea"><span data-pud-linea>${st.inv} × ${esc(f.corto)}</span><span data-pud-total>${eur(pu * st.inv)}</span></div>
            <div class="bubu-pud__nota">Montaje y envío en Península incluidos.</div>
          </div>
          <div class="bubu-tramos">
            <div class="bubu-tramos__f" data-tramo-frase>${esc(frase)}</div>
            <div class="bubu-tramos__lista">${t.map((u, i) => `<div class="bubu-tramos__t${st.inv >= u ? ' is-hecho' : ''}" data-tramo="${i}"><span class="bubu-tramos__ico">${check(10)}</span><span>Desde ${u} invitados · ${eur(tab[i])}</span></div>`).join('')}</div>
          </div>
        </div>
      </div>`;
  }

  paso5() {
    const st = this.st, ig = st.modelos === 'iguales', n = this.asignados(), lleno = n >= st.inv;
    const chips = this.chips([{ k: 'iguales', n: 'Todos igual', tag: 'Recomendado' }, { k: 'mezclar', n: 'Variado' }], st.modelos, 'data-wiz-modelos');
    const estado = ig
      ? `<div class="bubu-wiz__iguales">${n > 0 ? `Listo: los ${st.inv} slimes serán el mismo personaje.` : `Elige un personaje y los ${st.inv} slimes serán ese.`}</div>`
      : `<div class="bubu-asig${lleno ? ' is-lleno' : ''}"><div class="bubu-asig__cab"><span>${lleno ? `Repartidos los ${st.inv}.` : `Reparte los ${st.inv} slimes entre los personajes.`}</span><span class="bubu-asig__cont">${n} / ${st.inv}</span></div><div class="bubu-asig__barra"><i style="width:${Math.min(100, Math.round((n / Math.max(1, st.inv)) * 100))}%"></i></div></div>`;
    const grid = this.d.personajes.map((p) => {
      const q = st.asign[p.s] || 0, sel = q > 0;
      const stepper = !ig && sel;
      const txt = ig ? (sel ? 'Elegido' : 'Elegir') : (lleno ? 'Completo' : 'Añadir');
      return `
        <div class="bubu-pj${sel ? ' is-sel' : ''}" data-pj="${esc(p.s)}">
          <div class="bubu-pj__foto"><img src="${esc(p.img)}" alt="${esc(p.n)}" loading="lazy">${sel ? `<span class="bubu-pj__ok">${check(12)}</span>` : ''}</div>
          <div class="bubu-pj__cuerpo">
            <div class="bubu-pj__n">${esc(p.n)}</div>
            <div class="bubu-pj__meta">${esc([p.t, p.a].filter(Boolean).join(' · '))}</div>
            <div class="bubu-pj__acc">${stepper
              ? `<div class="bubu-pj__stepper"><button type="button" data-wiz-pj-dec="${esc(p.s)}" aria-label="Quitar uno de ${esc(p.n)}">−</button><span>${q}</span><button type="button" data-wiz-pj-inc="${esc(p.s)}" aria-label="Añadir uno de ${esc(p.n)}" ${lleno ? 'disabled' : ''}>+</button></div>`
              : `<button type="button" class="bubu-pj__add${ig && sel ? ' is-sel' : ''}${!ig && lleno ? ' is-lleno' : ''}" data-wiz-pj-add="${esc(p.s)}" ${!ig && lleno ? 'disabled' : ''}>${txt}</button>`}</div>
          </div>
        </div>`;
    }).join('');
    return `${chips}${estado}<div class="bubu-pj__grid">${grid || '<p class="bubu-wiz__sub">Ahora mismo no hay personajes disponibles para fiestas.</p>'}</div>`;
  }

  paso6() {
    const st = this.st;
    const extras = this.d.extras.map((e) => {
      const q = st.extras[e.k] || 0;
      return `
        <div class="bubu-ext${q > 0 ? ' is-sel' : ''}">
          <div class="bubu-ext__foto"><img src="${esc(e.img)}" alt="${esc(e.n)}" loading="lazy"></div>
          <div class="bubu-ext__cuerpo">
            <div class="bubu-ext__n">${esc(e.n)}</div>
            <div class="bubu-ext__meta">${esc(e.meta || '')}</div>
            <div class="bubu-ext__pie"><span class="bubu-ext__p">${eur(e.p)}</span>${q > 0
              ? `<div class="bubu-pj__stepper bubu-ext__stepper"><button type="button" data-wiz-ext-dec="${esc(e.k)}" aria-label="Quitar uno de ${esc(e.n)}">−</button><span>${q}</span><button type="button" data-wiz-ext-inc="${esc(e.k)}" aria-label="Añadir uno de ${esc(e.n)}">+</button></div>`
              : `<button type="button" class="bubu-ext__add" data-wiz-ext-inc="${esc(e.k)}" ${e.disponible === false ? 'disabled' : ''}>${e.disponible === false ? 'Agotado' : 'Añadir'}</button>`}</div>
          </div>
        </div>`;
    }).join('');
    return `
      <div class="bubu-ext__grid">${extras}</div>
      <div class="bubu-obs"><label class="bubu-obs__lbl" for="bubu-wiz-obs">Observaciones (opcional)</label><textarea id="bubu-wiz-obs" class="bubu-obs__area" rows="3" data-wiz-obs placeholder="${esc(this.d.textos.obs)}">${esc(st.obs)}</textarea></div>`;
  }

  paso7() {
    const st = this.st, f = this.formato(), pu = this.pud(), ex = this.extrasTotal(), tot = pu * st.inv + ex, sm = this.semaforo();
    const filas = [
      ['Celebración', st.cel, 1],
      ['Fecha de la fiesta', st.fecha ? fMedia(deIso(st.fecha)) : '—', 2],
      ['Formato', f.corto, 3],
      ['Invitados', esMovil() ? `${st.inv} invitados` : `${st.inv} invitados · ${eur(pu)} cada uno`, 4],
      ['Personajes', st.modelos === 'iguales' ? 'Todos igual' : `${Object.keys(st.asign).filter((k) => st.asign[k] > 0).length} personajes distintos`, 5],
    ];
    const chips = Object.keys(st.asign).filter((k) => st.asign[k] > 0).map((k) => { const p = this.personaje(k); return `${st.asign[k]} × ${p ? p.n : k}`; })
      .concat(Object.keys(st.extras).filter((k) => st.extras[k] > 0).map((k) => { const e = this.d.extras.find((x) => x.k === k); return `${st.extras[k]} × ${e ? e.n : k}`; }));
    // Versión corta para que quepa en UNA línea en móvil: «Llega con 5 días de margen. · Sale el Lun 21».
    const salida = st.fecha
      ? (sm && sm.lejana ? `Sale el ${fCorta(sm.salDate)}` : `Sale el ${DIA[this.salidaLote().getDay()]} ${this.salidaLote().getDate()}`)
      : 'Elige el día y te lo decimos';
    return `
      <div class="bubu-rep">
        <div class="bubu-rep__cab"><span class="bubu-rep__ico">${svg('M20 12v9H4v-9M2 7h20v5H2zM12 22V7m0 0c-1.5-2-4.5-3-5-1s3 2 5 1Zm0 0c1.5-2 4.5-3 5-1s-3 2-5 1Z', 16)}</span><span>Tu pack de fiesta</span></div>
        <div class="bubu-rep__estado bubu-rep__estado--arriba is-${sm ? sm.k : 'vacio'}"><span class="bubu-rep__punto"></span><span><b>${esc(sm ? sm.f : 'Elige la fecha de la fiesta')}</b> · ${esc(salida)}</span></div>
        ${filas.map(([l, v, p]) => `<div class="bubu-rep__fila"><span class="bubu-rep__l">${esc(l)}</span><span class="bubu-rep__v">${esc(v)}</span><button type="button" class="bubu-rep__cambiar" data-wiz-ir="${p}">Cambiar</button></div>`).join('')}
        <div class="bubu-rep__lleva"><div class="bubu-rep__k">QUÉ SE LLEVA CADA INVITADO</div><div class="bubu-rep__chips">${chips.map((c) => `<span>${esc(c)}</span>`).join('')}</div></div>
        <div class="bubu-rep__tot">
          <div class="bubu-rep__t"><span>${st.inv} × ${esc(f.corto)}</span><span>${eur(pu * st.inv)}</span></div>
          ${ex > 0 ? `<div class="bubu-rep__t"><span>Extras</span><span>${eur(ex)}</span></div>` : ''}
          <div class="bubu-rep__t"><span>Envío</span><span class="bubu-rep__inc">Incluido en Península</span></div>
          <div class="bubu-rep__sep"></div>
          <div class="bubu-rep__t bubu-rep__t--total"><span>Total</span><span>${eur(tot)}</span></div>
          <div class="bubu-rep__porinv">${eur(tot / Math.max(1, st.inv))} por invitado · IVA incluido</div>
        </div>
      </div>
      ${st.obs && st.obs.trim() ? `<div class="bubu-rep__obs"><span><span class="bubu-rep__k">TUS OBSERVACIONES</span><span>${esc(st.obs)}</span></span><button type="button" class="bubu-rep__cambiar" data-wiz-ir="6">Cambiar</button></div>` : ''}`;
  }

  rail() {
    const st = this.st, p = st.paso, f = this.formato(), pu = this.pud(), ex = this.extrasTotal(), tot = pu * st.inv + ex, sm = this.semaforo();
    const dCel = p > 1, dPack = p > 3, dInv = p > 4, dMod = p > 5, calc = dPack && dInv;
    const fila = (l, v, fuerte) => `<div class="bubu-rail__f"><span>${esc(l)}</span><span class="${fuerte ? 'is-fuerte' : ''}">${esc(v)}</span></div>`;
    const salida = st.fecha
      ? (sm && sm.lejana ? `Sale del Lab el lunes ${sm.salDate.getDate()} de ${MES[sm.salDate.getMonth()]}` : `Sale del Lab el próximo ${DIA[this.salidaLote().getDay()]} ${this.salidaLote().getDate()}`)
      : 'Te lo decimos al elegir el día';
    return `
      <div class="bubu-rail">
        <div class="bubu-rail__cab"><div class="bubu-rail__t">Tu pack</div><div class="bubu-rail__s">Precios especiales desde ${this.d.min} invitados</div></div>
        <div class="bubu-rail__bloque">
          ${fila('Celebración', dCel ? st.cel : '—', dCel)}
          ${fila('Fecha', st.fecha ? fCorta(deIso(st.fecha)) : '—', !!st.fecha)}
          ${fila('Pack', dPack ? f.etq : '—', dPack)}
          ${fila('Invitados', dInv ? st.inv : '—', dInv)}
          ${fila('Personajes', dMod ? (st.modelos === 'iguales' ? 'Todos igual' : 'Variado') : '—', dMod)}
        </div>
        <div class="bubu-rail__bloque">
          ${fila(calc ? `${st.inv} × ${f.corto}` : 'Slimes', calc ? eur(pu * st.inv) : '—', calc)}
          ${calc && ex > 0 ? fila('Extras', eur(ex), true) : ''}
          ${fila('Envío', 'Incluido en Península', false)}
        </div>
        <div class="bubu-rail__total${calc ? '' : ' is-vacio'}"><div class="bubu-rail__tf"><span>Total</span><span>${calc ? eur(tot) : '—'}</span></div><div class="bubu-rail__porinv">${calc ? `${eur(tot / Math.max(1, st.inv))} por invitado` : 'Dinos cuántos sois y lo calculamos'}</div><div class="bubu-rail__iva">IVA incluido</div></div>
        <div class="bubu-rail__estado is-${sm ? sm.k : 'vacio'}"><span class="bubu-rail__punto"></span><div><b>${esc(sm ? sm.f : 'Elige la fecha de la fiesta')}</b><div>${esc(salida)}</div></div></div>
        <div class="bubu-rail__pie"><b>Sin límite de invitados.</b><div>Fabricamos bajo demanda, lote a lote.</div></div>
      </div>`;
  }

  // Parche ligero mientras se arrastra el deslizador (sin repintar todo el paso).
  parcheInv() {
    const st = this.st, f = this.formato(), pu = this.pud(), t = this.d.tramos, tab = f.precios.map(Number);
    const q = (s) => this.querySelector(s);
    if (q('[data-inv-n]')) q('[data-inv-n]').textContent = st.inv;
    if (q('[data-pud-unit]')) q('[data-pud-unit]').textContent = eur(pu);
    if (q('[data-pud-linea]')) q('[data-pud-linea]').textContent = `${st.inv} × ${f.corto}`;
    if (q('[data-pud-total]')) q('[data-pud-total]').textContent = eur(pu * st.inv);
    if (q('[data-tramo-frase]')) q('[data-tramo-frase]').textContent = st.inv < t[1] ? `Con ${t[1]} invitados baja a ${eur(tab[1])} cada uno.` : st.inv < t[2] ? `Con ${t[2]} invitados baja a ${eur(tab[2])} cada uno.` : 'Estás en el mejor tramo.';
    this.querySelectorAll('[data-tramo]').forEach((el) => el.classList.toggle('is-hecho', st.inv >= t[Number(el.dataset.tramo)]));
    this.querySelectorAll('[data-wiz-inv-set]').forEach((el) => el.classList.toggle('is-sel', Number(el.dataset.wizInvSet) === st.inv));
    const menos = q('[data-wiz-inv="-1"]'); if (menos) menos.disabled = st.inv <= this.d.min;
    const r = q('[data-wiz-range]'); if (r) r.style.setProperty('--pct', `${Math.round(((Math.min(st.inv, this.d.max) - this.d.min) / (this.d.max - this.d.min)) * 100)}%`);
    if (!esMovil()) this.$rail.innerHTML = this.rail();
  }

  // ---------- eventos ----------
  /* ------------------------------------------------------------------
     EL EMBUDO, PARA EL PIXEL.

     Lo que hace falta saber de este asistente no es cuánta gente entra, sino en qué
     paso se cae: si la mitad abandona en «¿Cuántos invitados?», el problema es el
     precio por tramos, no el tráfico. Cada paso se avisa UNA sola vez por visita —
     ir y volver con «Atrás» lo contaría cinco veces y el embudo mentiría.

     Shopify.analytics.publish es la puerta oficial al sandbox de Eventos del cliente:
     el pixel no puede escuchar el DOM de la tienda, así que la tienda le habla a él.
     Todo va dentro de try: un pixel mal configurado no puede romper el configurador.
     ------------------------------------------------------------------ */
  avisa(nombre, datos) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(nombre, datos || {});
      }
    } catch (_) { /* el seguimiento nunca manda sobre la compra */ }
  }
  avisaPaso(p) {
    this._pasosVistos = this._pasosVistos || {};
    if (this._pasosVistos[p]) return;
    this._pasosVistos[p] = true;
    this.avisa('bubu_wizard_paso', {
      paso: p,
      pack: this.st.pack || '',
      invitados: Number(this.st.inv) || 0,
    });
  }

  /* El salto al cambiar de paso ya no es suave, y es a propósito. En el móvil un
     desplazamiento suave dura medio segundo largo, y durante ese medio segundo el
     PRIMER toque que das no abre nada: el navegador lo gasta en frenar el
     desplazamiento. Encadenando pasos con valores por defecto —pack, invitados— se
     pulsa «Siguiente» dos o tres veces seguidas, así que ese toque perdido caía justo
     ahí. Además, si la pregunta ya está a la vista no se mueve nada: moverse por
     moverse desorienta más de lo que ayuda. */
  irPaso(n) {
    this.set({ paso: Math.min(7, Math.max(1, n)) });
    this.avisaPaso(this.st.paso);
    const destino = Math.max(0, this.getBoundingClientRect().top + window.pageYOffset - 96);
    if (Math.abs(destino - window.pageYOffset) < 48) return;
    window.scrollTo({ top: destino, behavior: 'auto' });
  }
  onInput(e) {
    const t = e.target;
    if (t.matches('[data-wiz-range]')) {
      const inv = Math.min(this.d.max, Math.max(this.d.min, parseInt(t.value, 10) || this.d.min));
      if (inv === this.st.inv) return;
      // Mismo recorte que setInv, pero sin repintar el deslizador que se está arrastrando.
      const st = this.st; let asign = st.asign;
      if (st.modelos === 'iguales') { const k = Object.keys(st.asign).filter((x) => st.asign[x] > 0)[0]; asign = k ? { [k]: inv } : {}; }
      else if (this.asignados() > inv) { asign = {}; let queda = inv; Object.keys(st.asign).forEach((x) => { const q = Math.min(st.asign[x] || 0, queda); if (q > 0) { asign[x] = q; queda -= q; } }); }
      Object.assign(this.st, { inv, asign }); this.guardar(); this.parcheInv();
      return;
    }
    if (t.matches('[data-wiz-obs]')) { this.st.obs = t.value; this.guardar(); }
  }
  onClick(e) {
    const b = (sel) => e.target.closest(sel);
    let el;
    if ((el = b('[data-wiz-cel]'))) return this.set({ cel: el.dataset.wizCel });
    if ((el = b('[data-wiz-fecha]'))) {
      this.set({ fecha: el.dataset.wizFecha });
      // En móvil el semáforo (llega / justo / no llega) queda debajo del calendario,
      // fuera de la pantalla: se baja LO JUSTO para que se vea entero por abajo, con el
      // calendario todavía a la vista. Llevarlo arriba del todo parecía otra pantalla.
      // Sin scrollIntoView (regla del tema): se mide y se desplaza la ventana.
      if (esMovil()) {
        const sem = this.querySelector('.bubu-sem');
        if (sem) {
          const nav = this.querySelector('.bubu-wiz__nav');
          const tapa = nav ? nav.getBoundingClientRect().height : 0;
          const sobra = sem.getBoundingClientRect().bottom + tapa + 12 - window.innerHeight;
          if (sobra > 0) window.scrollTo({ top: window.pageYOffset + sobra, behavior: 'smooth' });
        }
      }
      return;
    }
    if ((el = b('[data-wiz-cal]'))) return this.set({ calOff: Math.min(6, Math.max(0, this.st.calOff + Number(el.dataset.wizCal))) });
    if ((el = b('[data-wiz-pack]'))) return el.classList.contains('is-agotado') ? undefined : this.set({ pack: el.dataset.wizPack });
    if ((el = b('[data-wiz-inv]'))) return this.setInv(this.st.inv + Number(el.dataset.wizInv));
    if ((el = b('[data-wiz-inv-set]'))) return this.setInv(el.dataset.wizInvSet);
    if ((el = b('[data-wiz-modelos]'))) return this.set({ modelos: el.dataset.wizModelos, asign: {} });
    if ((el = b('[data-wiz-pj-add]'))) {
      const s = el.dataset.wizPjAdd;
      if (this.st.modelos === 'iguales') return this.set({ asign: { [s]: this.st.inv } });
      if (this.asignados() >= this.st.inv) return;
      return this.set({ asign: Object.assign({}, this.st.asign, { [s]: 1 }) });
    }
    if ((el = b('[data-wiz-pj-inc]'))) { if (this.asignados() >= this.st.inv) return; const s = el.dataset.wizPjInc; return this.set({ asign: Object.assign({}, this.st.asign, { [s]: (this.st.asign[s] || 0) + 1 }) }); }
    if ((el = b('[data-wiz-pj-dec]'))) { const s = el.dataset.wizPjDec, a = Object.assign({}, this.st.asign); if ((a[s] || 0) <= 1) delete a[s]; else a[s] -= 1; return this.set({ asign: a }); }
    if ((el = b('[data-wiz-ext-inc]'))) { const k = el.dataset.wizExtInc; return this.set({ extras: Object.assign({}, this.st.extras, { [k]: (this.st.extras[k] || 0) + 1 }) }); }
    if ((el = b('[data-wiz-ext-dec]'))) { const k = el.dataset.wizExtDec, x = Object.assign({}, this.st.extras); if ((x[k] || 0) <= 1) delete x[k]; else x[k] -= 1; return this.set({ extras: x }); }
    if ((el = b('[data-wiz-ir]'))) return this.irPaso(Number(el.dataset.wizIr));
    if ((el = b('[data-wiz-atras]'))) return this.irPaso(this.st.paso - 1);
    if ((el = b('[data-wiz-sig]'))) { if (!this.aviso()) this.irPaso(this.st.paso + 1); return; }
    if ((el = b('[data-wiz-cancelar]'))) { this.reset(); if (window.BubuCart) window.BubuCart.abrirCesta(el); return; }
    if ((el = b('[data-wiz-add]'))) return this.anadir(el);
  }
  reset() {
    this.borrar();
    const base = estadoInicial();
    base.cel = this.d.celebraciones[0] || 'Cumple';
    base.inv = Math.max(this.d.min, 12);
    this.st = base;
    if (window.history && window.location.search.includes('editar=')) window.history.replaceState({}, '', window.location.pathname);
    this.render();
  }

  // ---------- carrito ----------
  lineas(pid) {
    const st = this.st, f = this.formato();
    const fechaTxt = st.fecha ? fMedia(deIso(st.fecha)) : '';
    const titulo = `${st.cel} · ${st.inv} invitados`;
    const comunes = {
      _pack_id: pid, _pack_tipo: 'cumple', _pack_titulo: titulo, _pack_fecha: fechaTxt,
      'Pack': titulo, 'Fecha de la fiesta': st.fecha, 'Formato': f.corto, 'Invitados': String(st.inv),
    };
    if (st.obs && st.obs.trim()) comunes['Observaciones'] = st.obs.trim();
    const items = Object.keys(st.asign).filter((k) => st.asign[k] > 0).map((k) => {
      const p = this.personaje(k);
      return { id: f.id, quantity: st.asign[k], properties: Object.assign({}, comunes, { 'Personaje': p ? p.n : k }) };
    });
    Object.keys(st.extras).filter((k) => st.extras[k] > 0).forEach((k) => {
      const e = this.d.extras.find((x) => x.k === k);
      if (e) items.push({ id: e.id, quantity: st.extras[k], properties: Object.assign({}, comunes, { _pack_extra: '1' }) });
    });
    return items;
  }
  async anadir(btn) {
    if (this._enviando || this.aviso() || !window.BubuCart) return;
    const st = this.st, pid = st.editando || `pk${Date.now()}`;
    const items = this.lineas(pid);
    if (!items.length) return this.irPaso(5);
    this._enviando = true;
    btn.disabled = true;
    btn.classList.add('is-cargando');
    // Se cambia el TEXTO, no el botón. Reescribir su innerHTML dejaba fuera del DOM los
    // nodos que navPinta usa para repintarlo, y a partir de ahí la barra se quedaba
    // muda: el botón no volvía a decir nunca lo que toca.
    if (this.$navSigT) this.$navSigT.textContent = st.editando ? 'Guardando…' : 'Añadiendo…';
    if (window.BubuAnim) window.BubuAnim.grande(btn);
    try {
      if (st.editando) {
        await window.BubuCart.get();
        const updates = {};
        window.BubuCart.cart.items.forEach((i) => { if (i.properties && i.properties._pack_id === pid) updates[i.key] = 0; });
        if (Object.keys(updates).length) await window.BubuCart.update(updates);
      }
      await window.BubuCart.add(items, { origen: btn });
      document.dispatchEvent(new CustomEvent('bubu:pack-cumple', { detail: { id: pid, editado: !!st.editando } }));
      /* El pack de fiesta es el evento que de verdad importa para los anuncios:
         ticket alto e intención clarísima. Va con su valor para que Google y Meta
         puedan optimizar por importe y no solo por conversión. */
      this.avisa('bubu_pack_fiesta', {
        pack: st.pack || '',
        invitados: Number(st.inv) || 0,
        valor: Math.round((this.pud() * st.inv + this.extrasTotal()) * 100) / 100,
        celebracion: st.cel || '',
        editado: !!st.editando,
      });
      setTimeout(() => this.reset(), 700);
    } catch (_) {
      btn.disabled = false;
      btn.classList.remove('is-cargando');
      this.render();
    } finally {
      this._enviando = false;
    }
  }
  async cargarDesdeCarrito(pid) {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await r.json();
      const ls = cart.items.filter((i) => i.properties && i.properties._pack_id === pid);
      if (!ls.length) return;
      const pr = ls[0].properties;
      const fmt = this.d.formatos.find((f) => ls.some((i) => Number(i.variant_id) === Number(f.id) && !i.properties._pack_extra)) || this.formato();
      const asign = {}, extras = {};
      ls.forEach((i) => {
        if (i.properties._pack_extra) { const e = this.d.extras.find((x) => Number(x.id) === Number(i.variant_id)); if (e) extras[e.k] = (extras[e.k] || 0) + i.quantity; return; }
        const p = this.d.personajes.find((x) => x.n === i.properties.Personaje);
        if (p) asign[p.s] = (asign[p.s] || 0) + i.quantity;
      });
      const inv = parseInt(pr.Invitados, 10) || Object.keys(asign).reduce((s, k) => s + asign[k], 0) || this.d.min;
      const cel = (pr.Pack || '').split(' · ')[0] || this.st.cel;
      Object.assign(this.st, {
        editando: pid, paso: 7, guardado: false, cel, fecha: /^\d{4}-\d{2}-\d{2}$/.test(pr['Fecha de la fiesta'] || '') ? pr['Fecha de la fiesta'] : '',
        pack: fmt.k, inv, modelos: Object.keys(asign).length > 1 ? 'mezclar' : 'iguales', asign, extras, obs: pr.Observaciones || '',
      });
    } catch (_) { /* sin carrito: configurador normal */ }
  }
}

if (!customElements.get('bubu-cumples')) customElements.define('bubu-cumples', BubuCumples);
